import ABSDialog from '@abs/core/ABSDialog';
import { styled } from '@mui/material/styles';
import ABSMessage from '@abs/core/ABSMessage';
import ABSSuspense from '@abs/core/ABSSuspense';
import AppContext from 'app/AppContext';
import { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { selectABSCurrentLayoutConfig } from 'app/store/abs/settingsSlice';
import FooterLayout1 from './components/FooterLayout1';
import LeftSideLayout1 from './components/LeftSideLayout1';
import NavbarWrapperLayout1 from './components/NavbarWrapperLayout1';
import RightSideLayout1 from './components/RightSideLayout1';
import ToolbarLayout1 from './components/ToolbarLayout1';
import SettingsPanel from '../shared-components/SettingsPanel';
import SystemMessages from '../shared-components/SystemMessages';
import { Fragment } from 'react';
import clsx from 'clsx';

const Root = styled('div')(({ theme, config }) => ({
  ...(config.mode === 'boxed' && {
    clipPath: 'inset(0)',
    maxWidth: `${config.containerWidth}px`,
    margin: '0 auto',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  }),
  ...(config.mode === 'container' && {
    '& .container': {
      maxWidth: `${config.containerWidth}px`,
      width: '100%',
      margin: '0 auto',
    },
  }),
  '& .topBarOverflow': {
    backgroundColor: 'rgb(35, 53, 78)'
  },
}));

function Layout1(props) {
  const config = useSelector(selectABSCurrentLayoutConfig);
  const appContext = useContext(AppContext);
  const { routes } = appContext;

  return (
    <Root id="abs-layout" config={config} className="w-full flex">
      {/* for smartphone app notch - not working*/}
			{/* <div className={clsx(classes.topBarOverflow, "absolute -top-64 w-full h-64 z-50")}></div> */}

      {config.leftSidePanel.display && <LeftSideLayout1 />}

      {config.navbar.belowheader && config.navbar.style === 'style-2' ?
			// if sidebar should be under header
			<main className="flex flex-col flex-auto min-w-0 z-10">
				{config.toolbar.display && (
					<ToolbarLayout1 className={config.toolbar.style === 'fixed' && 'sticky top-0'} />
				)}

				<div className={clsx("flex flex-auto min-w-0 sticky",config.toolbar.style === 'fixed' && 'top-64')}>
					{config.navbar.display && config.navbar.position === 'left' && <NavbarWrapperLayout1 />}

					<div className="flex flex-col min-w-0 flex-auto">
						<div className="flex flex-col flex-auto min-w-0 relative z-10">
							<SystemMessages />

							<ABSDialog />

							<ABSSuspense>{useRoutes(routes)}</ABSSuspense>

							{props.children}
						</div>
						
						{/* if footer is inside */}
						{config.footer.display && (
							<FooterLayout1 className={config.footer.style === 'fixed' && 'sticky bottom-0'} />
						)}
					</div>

					{config.navbar.display && config.navbar.position === 'right' && <NavbarWrapperLayout1 />}
				</div>

				{/* if footer should be over all */}
				{/* {config.footer.display && (
						<FooterLayout1 className={config.footer.style === 'fixed' && 'sticky bottom-0'} />
				)} */}
			</main>
			:
      <div className="flex flex-auto min-w-0">
        {config.navbar.display && config.navbar.position === 'left' && <NavbarWrapperLayout1 />}

        <main id="abs-main" className="flex flex-col flex-auto min-h-full min-w-0 relative z-10">
          {config.toolbar.display && (
            <ToolbarLayout1 className={config.toolbar.style === 'fixed' && 'sticky top-0'} />
          )}

          <div className="flex flex-col flex-auto min-h-0 relative z-10">
            <SystemMessages />

            <ABSDialog />

            <ABSSuspense>{useRoutes(routes)}</ABSSuspense>

            {props.children}
          </div>

          {config.footer.display && (
            <FooterLayout1 className={config.footer.style === 'fixed' && 'sticky bottom-0'} />
          )}
        </main>

        {config.navbar.display && config.navbar.position === 'right' && <NavbarWrapperLayout1 />}
      </div>
      }

      {/* <div className="sticky top-0 z-99">
				<SettingsPanel />
			</div> */}

      {config.rightSidePanel.display && <RightSideLayout1 />}
      <ABSMessage />
    </Root>
  );
}

export default memo(Layout1);
